// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1xmI5","assignButton":"CreateEditEquipmentSchedule_assignButton__1-Vho"};